import React from 'react'
import { Button } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
export default function ViewAndFilterButton({ text, state, height, fontSize, marginLeft, marginRight, marginTop, marginBottom,
    onClick, width }) {
    // Outlined while closed, brand-filled while its panel is open
    const btnStyle = {
        height, width, marginLeft, marginRight, marginTop, marginBottom,
        backgroundColor: state ? 'var(--color-primary)' : 'var(--color-surface)',
        color: state ? 'var(--color-text-on-brand)' : 'var(--color-primary)',
        border: `1px solid ${state ? 'var(--color-primary)' : 'var(--color-border-strong)'}`,
        textTransform: 'none', borderRadius: 'var(--radius-control)',
        fontWeight: 'normal', fontSize,
        padding: '10px 10px 10px 20px'
    }
    const iconStyle = { fontSize: 36 }
    return (
        <Button style={btnStyle} onClick={() => onClick && onClick()}
            endIcon={state ? <ArrowDropUpIcon style={iconStyle} /> : <ArrowDropDownIcon style={iconStyle} />}>
            {text}
        </Button>
    )
}
